import { useEffect, useRef } from 'react'
import { Box } from '@mui/material'

export default function CustomLoading({
  src = '/ProvocationFast.webm',
  width = 120,
  height = 120,
  startFraction = 0.5,
  sx,
  ...boxProps
}) {
  const videoRef = useRef(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const playFromFraction = () => {
      if (video.duration && startFraction > 0 && startFraction < 1) {
        video.currentTime = video.duration * startFraction
      }
      video.play().catch((err) =>
        console.warn('CustomLoading play failed:', err)
      )
    }

    if (video.readyState >= 1) {
      playFromFraction()
    } else {
      video.addEventListener('loadedmetadata', playFromFraction, { once: true })
    }
  }, [startFraction])

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        ...sx,
      }}
      {...boxProps}
    >
      <Box
        ref={videoRef}
        component="video"
        loop
        muted
        playsInline
        src={src}
        sx={{
          width,
          height,
          objectFit: 'contain',
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      />
    </Box>
  )
}